export const TEMPLATE_TYPES = {
  signinSocial: "signin-social",
  signinEmail: "signin-email",
  signup: "signup",
}
